import { useFlags } from "launchdarkly-react-client-sdk";

import { useAppSelector } from "app/hooks";
import { DIRECT_MAIL_DASHBOARD_FEATURE } from "constants/feature-flags";
import { selectCurrentPractice } from "features/auth/auth-slice";

/**
 * The single gate the route guard, the dashboard page, and the patient tab all read: the practice
 * is onboarded onto direct mail AND the LaunchDarkly flag is on. Both terms are required, so a
 * practice without Darwill data never sees the surface even if the flag is flipped on for it.
 */
export function useDirectMailEnabled(): boolean {
  const practice = useAppSelector(selectCurrentPractice);
  const flags = useFlags();
  return (
    Boolean(practice?.direct_mail_enabled) &&
    Boolean(flags[DIRECT_MAIL_DASHBOARD_FEATURE])
  );
}
